/**
 * Cross-route scratch space.
 *
 * `data` used to live here too — a string the websocket service wrote "true"
 * into on `doctorUnassignedWSEvent`, which three unrelated screens read and
 * answered with a page reload or a redirect. Nothing re-rendered when it
 * changed and only one screen ever cleared it, so it fired at arbitrary
 * moments and could eject a doctor from a record they had only just opened.
 * That event is a redux action now — see modules/ws/store/epics.
 *
 * `FetchRecordStatus` is a different thing and is still here: the records list
 * sets it immediately before `history.push`, and <RecordPageContainer/> reads it
 * on the very next mount to decide whether to resume an in-progress record or
 * take the next one from the queue.
 */
const myInitObject = {FetchRecordStatus: ""};

export default myInitObject
